import { render } from "./walletMenuEvmPcIndex.vue?vue&type=template&id=263d9019"
import script from "./walletMenuEvmPcIndex.vue?vue&type=script&lang=js"
export * from "./walletMenuEvmPcIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__